import { useMutation } from '@libs/use';

import * as API from '../requests';

type UseFreezeUnfreezeQueryParamsType = {
  onSuccess?: (...arg: any[]) => void;
  onReject?: (...arg: any[]) => void;
};

export type FreezeUnfreezeParams = {
  isFreeze: boolean;
  formModel: {
    isin: string;
    requestGatewayId: number;
    executorBrokerBranchId: number;
    description?: string;
  };
};

function freezeUnfreezeFactory(formModel: FreezeUnfreezeParams['formModel']) {
  return {
    instrumentIsin: formModel.isin,
    requestGatewayId: formModel.requestGatewayId,
    executorBrokerBranchId: formModel.executorBrokerBranchId,
    description: formModel.description ?? '',
  };
}

export default function useFreezeUnFreezeQuery({
  onSuccess,
  onReject,
}: UseFreezeUnfreezeQueryParamsType) {
  const {
    execute: freezeUnfreezeSymbol,
    isPending: isPendingFreezeUnfreezeSymbol,
    isSuccess: isSuccessFreezeUnfreezeSymbol,
    ...query
  } = useMutation(
    ({ isFreeze, formModel }: FreezeUnfreezeParams) =>
      isFreeze
        ? API.freeze(freezeUnfreezeFactory(formModel))
        : API.unfreeze(freezeUnfreezeFactory(formModel)),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    freezeUnfreezeSymbol,
    isPendingFreezeUnfreezeSymbol,
    isSuccessFreezeUnfreezeSymbol,
    ...query,
  };
}
